import React, { useEffect } from 'react'

import Header from '../../components/Header/Header'
import UnderHeader from '../../components/UnderHeader/UnderHeader'
import PageTitle from '../../components/PageTitle/PageTitle'
import Footer from '../../components/Footer/Footer'
import LogoPartner from '../../components/LogoPartner/LogoPartner'
import Subscribe from '../../components/Subscribe/Subscribe'
import CoperateContent from '../../components/CoperateContent/CoperateContent'

export default function Corperate() {
  useEffect(() => {
    window.scrollTo({ top:0 ,behavior: "smooth" })
  }, [])

  return (
    <div>
      <Header page={'corperate'} />
      <UnderHeader className={'corperate'} />
      <PageTitle mainTitle={'CORPORATE'} page={'CORPERATE'} />
      <CoperateContent />
      <Subscribe />
      <LogoPartner />
      <Footer />
    </div>
    
  )
}
